import React, { useContext, useRef, useId } from 'react'
import { useField } from 'formik'

import { styled, YStack, XStack } from 'tamagui'

import { Text } from '../Text'

import { FormFieldContext } from './shared'

export { FormFieldContext }

export const FormField = YStack.styleable<{
  name: string
  label?: string
  showError?: boolean
  hint?: string
}>(
  ({ name, label = name, showError = true, hint, children, ...props }, ref) => {
    const formElementRef = useRef()
    const fieldId = useId()

    return (
      <YStack gap='$1' flex={1} {...props} ref={ref}>
        <FormFieldContext.Provider value={{ name, fieldId, formElementRef }}>
          <XStack gap='$2' flexWrap='wrap'>
            {!!label && <Label size='$4'>{label}</Label>}
            {showError && <FormFieldError />}
          </XStack>

          {children}

          {!!hint && (
            <Text size='$4' fontStyle='italic' color='$grey7'>
              {hint}
            </Text>
          )}
        </FormFieldContext.Provider>
      </YStack>
    )
  }
)

const FormFieldError = () => {
  const formFieldContext = useContext(FormFieldContext)
  const [field, meta] = useField(formFieldContext)

  const message = meta.error

  if (!meta.touched) {
    return null
  }

  if (!message) {
    return null
  }

  if (typeof message === 'string') {
    return <ErrorText size='$4'>{message}</ErrorText>
  }

  return (
    <ErrorText size='$4'>
      {Object.values(message).find((value) => typeof value === 'string')}
    </ErrorText>
  )
}

export const Label = styled(Text, {
  name: 'FormLabel',
  tag: 'label',
  userSelect: 'none',
  color: '$grey7',
})

export const ErrorText = styled(Text, {
  name: 'FormError',
  userSelect: 'none',
  color: '$errorColor',
  fontWeight: '$5',
})
